import { EnergyGuideResponse } from '../models/EnergyGuideResponse';
import axiosClient from '../axiosBearerClient';
import { useQuery } from '@tanstack/react-query';

export const useGetEnergiesGuide = () => {
  const { isFetching, error, data, isError, refetch } = useQuery({
    queryKey: ['energies-guide'],
    retry: false,
    queryFn: async () => await axiosClient.get<EnergyGuideResponse[]>(`/energies-guide`),
  });

  return {
    isFetching,
    error,
    isError,
    data,
    refetch,
  };
};
